import { useEffect, useState } from "react";
import { ErrorServer } from "@/common/api/Error";
import {
	ProductTagsCollectionJson,
	RangeSliderState,
} from "@/types/Product.type";
import { BrandCollectionJson, FilterBrand } from "@/types/Brand.type";
import {
	getBrandsFilter,
	getMinMaxRangeFilter,
	getProductTagsSize,
} from "../api/shop/products";
import { Filter } from "@/common/types/Filter.type";

type FilerState = {
	sizes: ProductTagsCollectionJson;
	brands: BrandCollectionJson;
	brandsSearch: BrandCollectionJson;
} & RangeSliderState;

export default function useGetFilterProduct({
	collectionHandle,
}: {
	collectionHandle?: string;
}) {
	const LIMIT_TOTAL = 10;

	const [isLoading, setIsLoading] = useState(true);
	const [isLoadingBrand, setIsLoadingBrand] = useState(true);
	const [isLoadingSize, setIsLoadingSize] = useState(true);

	const [valueFilters, setValueFilters] = useState<FilerState>({
		priceMin: 0,
		priceMax: 0,
		sizes: {
			currentpage: 1,
			items: [],
			limit: LIMIT_TOTAL,
			total: 0,
		},
		brands: {
			currentpage: 1,
			items: [],
			limit: LIMIT_TOTAL,
			total: 0,
		},
		brandsSearch: {
			currentpage: 1,
			items: [],
			limit: LIMIT_TOTAL,
			total: 0,
		},
	});

	const [defaultBrandFilter, setDefaultBrandFilter] = useState<FilterBrand>({
		page: 1,
		limit: LIMIT_TOTAL,
		keyword: "",
		sort_by: "display_order",
		sort_type: "ASC",
	});
	const [defaultSizeFilter, setDefaultSizeFilter] = useState<
		Filter & { collection_id?: string | number }
	>({
		page: 1,
		limit: LIMIT_TOTAL,
		keyword: "",
		sort_by: "title",
		sort_type: "ASC",
		status: "",
	});

	useEffect(() => {
		(async () => {
			try {
				const { data: rangePrice } = await getMinMaxRangeFilter(
					collectionHandle
				);
				setValueFilters((pre) => {
					return {
						...pre,
						priceMax: Number(rangePrice.price_max),
						priceMin: Number(rangePrice.price_min),
					};
				});
			} catch (error) {
				// handlerError(errorRange)
			} finally {
				setIsLoading(false);
			}
		})();
	}, []);

	useEffect(() => {
		(async () => {
			try {
				setIsLoadingBrand(true);
				const filter = {
					page: defaultBrandFilter.page
						? Number.parseInt(defaultBrandFilter.page.toString())
						: 1,
					limit: LIMIT_TOTAL,
					sort_by: defaultBrandFilter.sort_by,
					sort_type: defaultBrandFilter.sort_type,
				};
				const { data: brands } = await getBrandsFilter(filter);
				setValueFilters((pre) => {
					return {
						...pre,
						brands: {
							...brands,
							items: [...pre.brands.items, ...brands.items],
						},
					};
				});
			} catch (error) {
				// handlerError(error)
			} finally {
				setIsLoadingBrand(false);
			}
		})();
	}, [defaultBrandFilter.page]);

	useEffect(() => {
		(async () => {
			try {
				setIsLoadingSize(true);
				const filter = {
					...defaultSizeFilter,
					collection_id: collectionHandle,
					page: Number.parseInt(defaultSizeFilter.page.toString()),
					limit: LIMIT_TOTAL,
				};
				const tagSizes = await getProductTagsSize(filter);
				setValueFilters((pre) => {
					return {
						...pre,

						sizes: {
							...tagSizes.data,
							items: [...pre.sizes.items, ...tagSizes.data.items],
						},
					};
				});
			} catch (error) {
				// handlerError(error)
			} finally {
				setIsLoadingSize(false);
			}
		})();
	}, [defaultSizeFilter.page]);

	useEffect(() => {
		(async () => {
			try {
				if (!defaultBrandFilter.keyword) {
					setValueFilters((pre) => {
						return {
							...pre,
							brandsSearch: {
								currentpage: 1,
								items: [],
								limit: LIMIT_TOTAL,
								total: 0,
							},
						};
					});
					return;
				}
				setIsLoadingBrand(true);

				const filter = {
					...defaultBrandFilter,
					page: 1,
					limit: LIMIT_TOTAL,
				};
				const { data: brands } = await getBrandsFilter(filter);
				setValueFilters((pre) => {
					return {
						...pre,
						brandsSearch: {
							...brands,
							items: [...brands.items],
						},
					};
				});
				setIsLoadingBrand(false);
			} catch (error) {
				// handlerError(error)
			} finally {
			}
		})();
	}, [defaultBrandFilter.keyword]);

	return {
		isLoading,
		isLoadingBrand,
		valueFilters,
		setDefaultBrandFilter,
		defaultBrandFilter,
		defaultSizeFilter,
		setDefaultSizeFilter,
		isLoadingSize,
		setIsLoadingSize,
	};
}
